import PortalApi from "../generated/api/PortalApi";
import ApiClient from "../generated/ApiClient";

/**
 * Customer portal: approver-facing magic-link sessions, stored per account via
 * the shared data-cache helpers (localStorage with cookie fallback) and
 * deliberately separate from the User session (window.$A.Auth).
 */
class PortalService {
  constructor() {
    this.PortalApi = new PortalApi();
  }

  sessionKey(accountPublicId) {
    return `portal_session_${accountPublicId}`;
  }

  GetSession(accountPublicId) {
    const session = window.$A.LoadDataCache(this.sessionKey(accountPublicId));
    if (!session) return null;
    // The cache helpers don't expire localStorage entries; the token's own
    // validTo is the authority either way.
    if (!session.token || new Date(session.validTo) <= new Date()) {
      this.ClearSession(accountPublicId);
      return null;
    }
    return session;
  }

  SaveSession(session) {
    window.$A.SaveDataCache(this.sessionKey(session.accountPublicId), session, 30);
  }

  ClearSession(accountPublicId) {
    window.$A.DeleteDataCache(this.sessionKey(accountPublicId));
    // De-authenticate the shared client too. If a normal user session is
    // still live in this tab (portal never touches $A.Auth), restore its
    // token so owner login keeps working after a portal sign-out.
    const auth = window.$A.Auth;
    ApiClient.instance.authentications["AccessToken"].apiKey =
      auth && auth.apiToken && auth.apiToken.token ? auth.apiToken.token : null;
  }

  // Installs the portal token on the shared API client for this page load,
  // same pattern as ReviewService.SetLoggedInApprover. Does not touch $A.Auth.
  InstallSession(session) {
    ApiClient.instance.authentications["AccessToken"].apiKey = session.token;
  }

  async GetAccountInfo(accountPublicId) {
    return await window.$A.HandleApiResponse(
      this.PortalApi.getAccountInfo(accountPublicId),
      "",
      true
    );
  }

  async RequestMagicLink(accountPublicId, email) {
    return await window.$A.HandleApiResponse(
      this.PortalApi.requestMagicLink(accountPublicId, {
        portalMagicLinkRequest: { email: email },
      }),
      "",
      true
    );
  }

  // Returns the saved session on success, null when the link is expired/used.
  async ExchangeSession(magicToken) {
    const session = await window.$A.HandleApiResponse(
      this.PortalApi.exchangeSession(magicToken),
      "",
      true
    );
    if (!session || !session.token) {
      return null;
    }
    this.SaveSession(session);
    return session;
  }

  async GetProofs() {
    return await window.$A.HandleApiResponse(
      this.PortalApi.getProofs(),
      "",
      true
    );
  }
}

export default PortalService;
